import { z } from 'zod';
import { MARKETING_OPT_OUT_FIELD_ID } from '../../../../../netlify/edge-functions/lead-cookies-geolocation';

export const marketingOptOutSchema = z.object({
  [MARKETING_OPT_OUT_FIELD_ID]: z.boolean().optional(),
});
